import React, { useState, Dispatch, SetStateAction } from 'react';
import {
  Row,
  Typography,
  Input,
  DatePicker,
  Radio,
  Slider,
  ConfigProvider,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { RadioChangeEvent } from 'antd/lib/radio';
import { SliderValue } from 'antd/lib/slider';
import i18n from 'i18next';
import CZ from 'antd/lib/locale-provider/cs_CZ';
import IT from 'antd/lib/locale-provider/it_IT';
import EN from 'antd/lib/locale-provider/en_US';
import 'moment/locale/cs';
import 'moment/locale/it';

export interface SliderMenuState {
  title: string;
  unit: string;
  value: any;
}

export interface ConsumptionProps {
  setConsumption?: Dispatch<SetStateAction<undefined>>;
  consumption: string;
}

export const DateTime: React.FC = () => {
  const dateTimeFormat = `ddd, MMM D, YYYY, h:mm a`;
  return (
    <Row>
      <Typography.Text className="filter-menu-title">
        {i18n.t('Date and Time')}
      </Typography.Text>
      <Input.Group className="filter-buttons filter-restrictions-menu filter-input-group">
        <span>From</span>
        <ConfigProvider
          locale={
            i18n.language === 'cz' ? CZ : i18n.language === 'it' ? IT : EN
          }
        >
          <DatePicker
            showTime
            style={{ width: '100%' }}
            format={dateTimeFormat}
          />
        </ConfigProvider>
      </Input.Group>
      <Input.Group className="filter-buttons filter-restrictions-menu filter-input-group">
        <span>To</span>
        <ConfigProvider
          locale={
            i18n.language === 'cz' ? CZ : i18n.language === 'it' ? IT : EN
          }
        >
          <DatePicker
            showTime
            style={{ width: '100%' }}
            format={dateTimeFormat}
          />
        </ConfigProvider>
      </Input.Group>
    </Row>
  );
};

export const Consumption: React.FC<ConsumptionProps> = ({
  setConsumption,
  consumption,
}) => {
  const [radioValue, setRadioValue] = useState(consumption);
  const { t } = useTranslation();
  const onRadioValueChange = (e: RadioChangeEvent) => {
    setRadioValue(e.target.value);
    setConsumption && setConsumption(e.target.value);
  };

  return (
    <Row className="restrictions-wrapper">
      <Typography.Text className="filter-menu-title">
        {t('Type of Consumption')}
      </Typography.Text>
      <Radio.Group
        value={radioValue}
        buttonStyle="solid"
        className="filter-restrictions-menu filter-radio-group"
        onChange={onRadioValueChange}
      >
        <Radio.Button value="Take away" className="radio-button-left-radius">
          {t('Take away')}
        </Radio.Button>
        <Radio.Button value="Eat with">{t('Eat with')}</Radio.Button>
        <Radio.Button value="Both" className="radio-button-right-radius">
          {t('Both')}
        </Radio.Button>
      </Radio.Group>
    </Row>
  );
};

export const SliderMenu: React.FC<SliderMenuState> = ({
  title,
  unit,
  value,
}) => {
  const [sliderValue, setSliderValue] = useState<number | [number, number]>(0);

  const onSliderValueChange = (e: SliderValue) => {
    setSliderValue(e);
  };

  return (
    <Row>
      <Typography.Text className="filter-menu-title">{title}</Typography.Text>
      <Typography.Text className="filter-menu-extra">
        {`${sliderValue} ${unit}`}
      </Typography.Text>
      <Slider
        value={sliderValue}
        min={0}
        max={50}
        onChange={onSliderValueChange}
      />
    </Row>
  );
};
